import { Component, OnInit } from "@angular/core";

@Component({
  standalone: false,
    selector: 'app-view',
    template: `<router-outlet></router-outlet>`
})

export class ViewsComponent implements OnInit {

    constructor() { }

    ngOnInit() {
        
    }
}